import React from 'react';
import { Link } from 'react-router-dom';

// Painel administrativo vive em outro domínio/porta: a URL vem do build
// (REACT_APP_ADMIN_URL, definida no docker-compose a partir de PUBLIC_ADMIN_URL).
const ADMIN_URL = (process.env.REACT_APP_ADMIN_URL || 'http://localhost:3001').replace(/\/$/, '');

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__content">
        <p className="site-footer__text">
          © 2026 Grupo Vilarouca — Canal de Ética, Integridade e Ouvidoria
        </p>
        <nav className="site-footer__nav">
          <Link to="/transparencia" className="site-footer__link">
            Transparência e FAQ
          </Link>
          <Link to="/privacidade" className="site-footer__link">
            Política de Privacidade
          </Link>
          <Link to="/termos" className="site-footer__link">
            Termos de Uso
          </Link>
          <a href={`${ADMIN_URL}/login`} className="site-footer__link site-footer__link--admin">
            <span aria-hidden="true">🔒</span> Área administrativa
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
